import cn from '@/lib/clsxm';

import { CardMedia } from '@/components/@base/card';
import Container from '@/components/@base/container';
import Props from '@/components/shared/components/cards/demo/media/type';

import imagesList from '@/constant/images-list';
import ImageModel from '@/models/image.model';

export default function Media({ isHovered, cover }: Props) {
  const srcValue =
    cover && typeof cover === 'string'
      ? cover
      : (cover as ImageModel)?.publicLink || imagesList.images.demoCover;
  return (
    <Container className='relative h-full w-full overflow-hidden'>
      <CardMedia
        className={cn(
          'top-0 left-0 h-full w-full object-cover object-bottom transition-all duration-[2000ms] ease-in-out md:object-top',
          isHovered && 'md:object-bottom',
        )}
        fill
        src={srcValue}
        alt={(cover as ImageModel)?.title || 'demo cover'}
      />
    </Container>
  );
}
